export const ACTIONS = {
    FETCH: 'fetch',
    CREATE: 'add',
    DELETE: 'delete',
    UPDATE: 'update',
    VIEW: 'view',

    REMINDER: {
        CREATE: 'reminder-create',
    }
  }